/**
 * AdminThresholds — editor for `config.alertThresholds` per-branch. Read-only
 * for Wave 2 (displays the thresholds currently returned by `/v3/config/alert-thresholds`);
 * Wave 3 adds the `PUT /v3/config/alert-thresholds/{id}` write path.
 */

import { Pill } from '@/components/primitives';
import { useConfig } from '@/contexts/ConfigContext';

export function AdminThresholds(): JSX.Element {
  const { config } = useConfig();
  return (
    <div className="module-page">
      <header className="module-page__header">
        <div style={{ display: 'flex', gap: 'var(--sp-6)', alignItems: 'center' }}>
          <h1>RPM — Alert thresholds</h1>
          <Pill variant="muted">Admin</Pill>
        </div>
        <p className="module-landing__scope">
          Thresholds that trigger the red banner on the RPM supervisor home.
          Editable in Wave 3 via <code>PUT /v3/config/alert-thresholds/&#123;id&#125;</code>.
        </p>
      </header>

      {config.alertThresholds.length === 0 ? (
        <div style={{ padding: 'var(--sp-9)', background: 'var(--info-bg)', color: 'var(--info-text)', borderRadius: 'var(--r-md)', border: '1px solid var(--pcb-blue)' }}>
          No alert-threshold rows loaded yet. Either <code>/v3/config/alert-thresholds</code>
          returned 503 (initializing) or the seed script has not been run.
        </div>
      ) : (
        <table className="grid-table" aria-label="Alert thresholds">
          <thead>
            <tr>
              <th>Name</th>
              <th>Metric</th>
              <th>Op</th>
              <th>Threshold</th>
              <th>Severity</th>
              <th>Category</th>
              <th>Enabled</th>
            </tr>
          </thead>
          <tbody>
            {config.alertThresholds.map((t) => (
              <tr key={t.thresholdId}>
                <td>{t.name}</td>
                <td>{t.metricKey}</td>
                <td>{t.comparisonOp}</td>
                <td>{t.thresholdValue}</td>
                <td>{t.severity}</td>
                <td>{t.category}</td>
                <td>{t.isActive === false ? <Pill variant="muted">Disabled</Pill> : <Pill variant="ok">Active</Pill>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
